import { useEffect, FC } from 'react';
import { ReleaseComponentPageView } from './ReleaseComponentPageView';
import { useListStore } from './hooks';

export const ReleaseComponentPage: FC = () => {
  const { fetchReleaseComponents } = useListStore();

  useEffect(() => {
    void fetchReleaseComponents();
  }, [fetchReleaseComponents]);

  return <ReleaseComponentPageView />;
};
